module.exports = __webpack_public_path__ + "img/site-logo.372e35e7.svg";